import * as Yup from 'yup'
import { yupResolver, SchemaOf } from '@hookform/resolvers/yup'
import { UserFormValues } from 'components/containers/settings/users/AddEditUserBlade'

const createUserValidationSchema: SchemaOf<UserFormValues> = Yup.object({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  phoneNumber: Yup.string().nullable(),
  allowedYardNameList: Yup.array().of(Yup.string()).min(1, 'Users must have access to at least one yard'),
  greensparkRole: Yup.string().required('Role is required') as any,
  orgModeEnabled: Yup.boolean().nullable(),
  setInitialPasswordManually: Yup.boolean(),
  initialPassword: Yup.string().when('setInitialPasswordManually', {
    is: true,
    then: schema =>
      schema
        .required('Temporary password is required')
        .min(8, 'Must be at least 8 characters')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])/,
          'Must contain at least 1 number, special character, uppercase & lowercase',
        ),
    otherwise: schema => schema.notRequired(),
  }),
})

// Exported function to get the form options based on whether we are creating or updating
export const getFormOptions = () => ({
  resolver: yupResolver(createUserValidationSchema),
})

export default createUserValidationSchema
